(function($)
{
    $.extend(true, orion, {
        api: {
            sessionUpdate: {}
        }
    });

    var api = orion.api.sessionUpdate;
    var uri = '/api-session-update';

    function ping(customerId)
    {
        return $.ajax({
            url: uri + '/' + customerId,
            cache: false,
            method: 'GET'
        });
    }

    api.ping = ping;
})(jQuery);
